import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const HeaderMegaMenuMenuHeading = ({ children, color, href, onClick }) => <h3
    className={`c-header-nav__item  c-header-nav__heading  ${color ? `c-header-nav__heading--${color}` : ''}`}
  >
    <Button
      className="c-header-nav__link  c-header-nav__link--heading u-hide@desktop"
      color="none"
      onClick={onClick}
    >
      <span className="c-header-nav__text">{children}</span>
      <Icon
        icon="arrow-right"
        className="c-header-nav__icon  c-header-nav__icon--right"
      />
    </Button>

    {href ? (
      <Button
        className="c-header-nav__link  c-header-nav__link--heading u-show@desktop"
        color="none"
        href={href}
      >
        <span className="c-header-nav__text">{children}</span>
      </Button>
    ) : (
      <div
        className="c-header-nav__link  c-header-nav__link--heading u-show@desktop"
        color="none"
      >
        <span className="c-header-nav__text">{children}</span>
      </div>
    )}
  </h3>

export default HeaderMegaMenuMenuHeading;

HeaderMegaMenuMenuHeading.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

HeaderMegaMenuMenuHeading.defaultProps = {
  color: '',
  href: '',
  onClick: () => {},
};
